import React, { useEffect, useState } from 'react'

import { createBankAccount } from '../../../utilities/api'

import Button from 'react-bootstrap/Button'

import PayoutBusinessType, { isPayoutBusinessType } from '../PayoutBusinessType'
import { Spinner } from '../../LoadingContainer/Spinner'

export default function LinkBankAccountBtn({
  marginTop,
  label = 'Link bank account',
  initialBusinessType = 'individual',
  currentBusinessType,
}) {
  const [businessType, setBusinessType] = useState(
    isPayoutBusinessType(initialBusinessType)
      ? initialBusinessType
      : 'individual'
  )
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (isPayoutBusinessType(initialBusinessType)) {
      setBusinessType(initialBusinessType)
    }
  }, [initialBusinessType])

  const startOnboarding = () => {
    setIsSaving(true)
    setError('')
    const payload = { businessType }
    if (isPayoutBusinessType(currentBusinessType)) {
      payload.currentBusinessType = currentBusinessType
    }
    return createBankAccount(payload)
      .then((res) => {
        if (res?.data?.link) {
          window.location.assign(res.data.link)
          return
        }
        if (res?.data?.ready) {
          window.location.reload()
          return
        }
        setError('Unable to open bank account setup. Try again.')
        setIsSaving(false)
      })
      .catch((err) => {
        console.error(err)
        setError('Unable to open bank account setup. Try again.')
        setIsSaving(false)
      })
  }

  return (
    <div>
      <PayoutBusinessType
        id={`${label.replace(/\s+/g, '-').toLowerCase()}-business-type`}
        value={businessType}
        onChange={setBusinessType}
        currentBusinessType={currentBusinessType}
        disabled={isSaving}
      />
      {error && <p className="small text-danger mb-2">{error}</p>}
      <Button
        onClick={startOnboarding}
        disabled={isSaving}
        size="lg"
        className={`icon-button w-100 ${!isSaving ? 'btn-plus' : ''} ${marginTop ? `m-${marginTop}` : ''}`}
      >
        {isSaving ? <Spinner /> : label}
      </Button>
    </div>
  )
}
